import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgColorpaletteIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14.741,
	height: 14.741,
	viewBox: "0 0 14.741 14.741",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H14.741V14.741H0Z",
			fill: "none",
			stroke: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M8.142,14.284A6.142,6.142,0,0,1,8.142,2c3.384,0,6.142,2.481,6.142,5.528A3.688,3.688,0,0,1,10.6,11.213H9.512a.3.3,0,0,0-.307.307.324.324,0,0,0,.08.2,1.562,1.562,0,0,1,.393,1.026A1.536,1.536,0,0,1,8.142,14.284Zm0-11.056a4.914,4.914,0,1,0,0,9.827.3.3,0,0,0,.307-.307.332.332,0,0,0-.086-.215A1.531,1.531,0,0,1,9.512,9.985H10.6a2.456,2.456,0,0,0,2.457-2.457C13.056,5.157,10.851,3.228,8.142,3.228Z",
			transform: "translate(-0.772 -0.772)",
			fill: "#2C3B45"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "b",
			cx: 1,
			cy: 1,
			r: 1,
			transform: "translate(3 6)",
			fill: "#2C3B45"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "b",
			cx: 1,
			cy: 1,
			r: 1,
			transform: "translate(5 4)",
			fill: "#2C3B45"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "b",
			cx: 1,
			cy: 1,
			r: 1,
			transform: "translate(8 4)",
			fill: "#2C3B45"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "b",
			cx: 1,
			cy: 1,
			r: 1,
			transform: "translate(10 6)",
			fill: "#2C3B45"
		})
	]
});
export default SvgColorpaletteIcon;
